import { SeriesCard } from "../../common/SeriesCard.js";
import { locale } from "../../../services/LocaleService.js";

export const CuratedSection = (items) => {
    const container = document.createElement('div');

    if (!items || items.length === 0) return container;

    container.className = "animate-fade-in";
    container.id = "curated-section";
    container.innerHTML = `
        <div class="flex items-center gap-2 mb-4 px-1 md:px-0">
            <span class="material-symbols-outlined text-purple-600">recommend</span>
            <h2 class="text-xl font-bold text-gray-900">${locale.t('main.todays_pick')}</h2>
        </div>
    `;

    // 1+4 Bento Grid Layout
    // Mobile: 1 Large + 2x2 Grid (Total 5)
    // Desktop (MD+): 1 Large (Left) + 2x2 Grid (Right)
    const gridDiv = document.createElement('div');
    gridDiv.className = "grid grid-cols-2 md:grid-cols-3 gap-4"; // 3 Columns

    items.forEach((item, idx) => {
        const isFirst = idx === 0;

        const card = SeriesCard(item, {
            isBig: false, // Turn off conventional 'Big' (2:1)
            variant: isFirst ? 'hero-vertical' : 'standard',
            overlayStats: isFirst, // Show stats on overlay for the big one
            badges: isFirst ? ['editor', 'hot'] : ['editor'],
            marketing: item._marketing
        });

        if (isFirst) {
            // [Item 1] Large Vertical (Spans 2 Rows, 1 Column on Desktop? No, usually 1 Col x 2 Rows if 3-col grid)
            // Wait, if 3 cols: [ 1 ] [ 2 ] [ 3 ] -> This is row 1
            //                  [ 1 ] [ 4 ] [ 5 ] -> This is row 2
            // So Item 1: row-span-2.
            // On Mobile (2 cols):
            // [ 1 (col-span-2) ]
            // [ 2 ] [ 3 ]
            // [ 4 ] [ 5 ]
            card.className = "col-span-2 md:col-span-1 md:row-span-2 h-auto md:h-full relative group cursor-pointer overflow-hidden rounded-xl bg-white dark:bg-zinc-900 border border-gray-100 dark:border-zinc-800 hover:shadow-lg transition-all duration-300";
        } else {
            // [Items 2-5] Standard Cards
            // They naturally fill the remaining cells.
            // On mobile, items 2-5 form a 2-col grid implicitly.
        }

        gridDiv.appendChild(card);
    });

    container.appendChild(gridDiv);
    return container;
};
